<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Odločbe</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezoneBranje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
              <kendo-multiselect
                        :data-source="columns"
                        :data-text-field="'title'"
                        :data-value-field="'field'"
                        :placeholder="'Skrij stolpce'"
                         @select="skrijStolpec"
                        @deselect="prikaziStolpec"
                        :filter="'contains'"
                        :auto-width="true"
                        >
            </kendo-multiselect>
        </div>
          <div class="grid-wrapper">
    <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                     
                         :pageable="{ buttonCount: 4, pageSizes: [10,50,100,'all'] }"
                        :data-items="dataResult"
                        :skip="skip"
                        :take="take" 
                        :sort="sort" 
                        :resizable="true"
                      
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"

                        
                       
                        @pagechange="pageChangeHandler"
                       
                        
                                              

                         
                        
                                               >
                 
                    
                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                             <button 
                                title="Išči"
                                class="k-button k-primary"
                                @click="naloziPodatke"
                            >
                                Išči
                            </button>
                        <button
                                title="Export to Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        </div>
                            
                        </toolbar>
                    </Grid>
                       <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
                    </div>
                    </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
Vue.component('kendo-multiselect', MultiSelect);


import { process } from '@progress/kendo-data-query';


 

Vue.component('Grid', Grid);
Vue.component('toolbar', GridToolbar);
Vue.component('dropdownlist', DropDownList);



export default {
  props:['sezona'],
    data () {
        return {
         
            dataSezona:this.sezona,
           
            loading:false,


            filter: null,
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            dataResult: [],
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            
          

           

        }
    },
    created () {

      

      
      if(!this.sezona)
        this.dataSezona={sezona:Math.max(...this.sezoneBranje.map(s=>s.sezona))};
      else
      this.dataSezona={sezona:this.sezona};
    // this.loadVse({sezona:this.dataSezona.sezona});
 
    },
    computed: {
          columns() {

            var columns= [
                 { field: "kmgmid", title:"KMG-MID",width: "210px",footerCell: this.nogaNazivVsot},
            { field: "kontrolnastevilka", title:"Kont. št.",width: "100px",footerCell: this.nogaStMidov},
            { field: "imenosilca", title:"Nosilec",width: "150px"},
                { field: "vrstaodlocbe", filterable:false, title:"Vrsta odločbe",width: "200px",},
                  { field: "datumizdaje", title:"Dat. izdaje",width: "80px",filterable:false,cell:this.formatDate},
                  { field: "datumveljavnosti", title:"Dat. veljavnosti",width: "80px",filterable:false,cell:this.formatDate},
              
                  
              /*   { field: "kolicina", title:"Količina",width: "100px",filterable:false,type: "number",footerCell: this.nogaVsotaKolicina,width: "150px",format: '{0:n2}'},
                { field: "merskaenotanaziv", title:"Enota",width: "100px",filterable:false},
                //{ field: "enota", title:"Enota", type:"string",filterable:false,width: "80px"},
                { field: "veljavnostcertifikataod", filterable:false, title:"Datum določitve statusa",width: "170px", cell:this.formatDate},
                //template: "#= kendo.toString(kendo.parseDate(veljavnostcertifikataod, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"},
                //filter:'date',format: "{0:d}"},
               // { field: "veljavnostcertifikatado", title:"Veljavnost statusa", type:"string",editor: 'date',width: "150px",format: '{0:d}'},

                { field: "statuspridelkanaziv", title:"Status",width: "150px"},
                */
          
                { field: "statuspridelovalca", title:"Status KMG-MID",width: "150px"},
                //  { field: "opomba", title:"Opomba",width: "100px",filterable:false},
                // nekaj z opombo naredit...
                { field: "postnastevilka", title:"Poštna številka"},
                { field: "posta", title:"Pošta"},
                { field: "obcina", title:"Občina"},
                { field: "statisticnaregija", title:"Statistična regija"},
                
           
            ];
            if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
                columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});
            


            return columns;
        },
        ...mapState('users', ['userDetails','sezoneBranje']),
         ...mapState({gridData(state) {
      
          return state.odlocba.odlocba;
        }}),         
    
           },
      watch: {
        skip(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        take(newValue, oldValue){
            console.log(`Updating from ${oldValue} to ${newValue}`);
            
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                group: this.group
            }
        this.dataResult = process( this.gridData, dataState);
        },
       gridData(newValue, oldValue) {
  

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);

        }
    }
},
    methods: {

        ...mapActions('odlocba', ['loadVse']),
         naloziPodatke: async function(e){
            this.loading=true;
            if(!this.sezona){
                this.dataSezona={sezona:Math.max(...this.sezoneBranje.map(s=>s.sezona))};
                this.sezona=this.dataSezona.sezona;
            }
            else
                this.dataSezona={sezona:this.sezona};
        this.loadVse(this.dataSezona).then(()=>this.loading=false);
        },
skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
           
        },
        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.gridData, dataState);
        },
        nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Število unikatnih MID-ov:']);
        },
        nogaVsotaKolicina: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data)
            return h('span', {}, [kendo.toString(this.dataResult.data.reduce((acc, current) => acc+=current.kolicina, 0),"n2")]);
        },
       
        nogaStMidov: function (h, emptyElement , props, listeners ) {
          if(this.dataResult.data){
            var counts = {};
                for (var i = 0; i < this.dataResult.data.length; i++) {
                     counts[this.dataResult.data[i][props.field]] = 1 + (counts[this.dataResult.data[i][props.field]] || 0);
                }
                 return h('span', {}, [kendo.toString(Object.keys(counts).length,"n0")]);
            }
           
        },
        formatDate: function (h, emptyElement , props, listeners ) {
        
            return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
    

      
        sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;

            this.$router.push({ name: 'odlocbe', params: { sezona:sezona.sezona} })
            this.dataSezona=sezona;
          //  this.loadVse(this.dataSezona);



        },

        
        createAppState: function(dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
         
            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
         

        },
      
        exportExcel () {
            saveExcel({
                data: process(this.gridData, {sort: this.sort,filter: this.filter}).data,
                fileName: this.dataSezona.sezona+"_ODLOCBE",
                columns: this.columns.filter(i=>!i.hidden)
            });
        },
        
     
        pageChangeHandler: function(event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        }
        
    }
};
</script>

